<template>
   <div>
      <section-bar v-if="downloadfiletype != 4">
         Document
      </section-bar>
      <div v-if="loadingerror" class="doc-view padt-24 padb-24 text-danger">
         <i class="mart-24 padl-12 fas fa-exclamation-triangle"></i> 
         Error Loading Document
         <span class="font-smaller text-muted">({{docpath}})</span>
      </div>
      <div v-if="loading" class="doc-view padt-24 padb-24 text-center">
         <i class="mart-24 fas fa-spinner fa-spin ml-orange fa-lg"></i>
      </div>
      <div v-if="!loading && !loadingerror" :class="{'doc-view':keepdefaultcss}"  class="marb-12">
         <div class="inner-doc-view">
            <pdf 
               name="comm-stmt"
               :src="pdfsrc" 
               v-for="i in numPages"
               :key="i"
               :page="i"
               style="display: inline-block; height: 100%; width: 100%;"
            ></pdf>
         </div>
      </div>
   </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
   name: "PdfViewer",
   components: {
      pdf
   },
   props: { 
      'downloadfiletype': Number,
      'docpath': String,
      'title': String,
      'keepdefaultcss': Boolean
   },
   data() {
      return {
         numPages: undefined,
         pdfsrc: null,
         loading: true,
         waitTimeMS: 1000, //1 seconds
         loadingerror: false
      }
   },
   mounted() {
      let payload = {
         AppUserId : this.$store.getters.appUser.userId,
         DownloadFileType: this.downloadfiletype,
         Path: this.docpath,
         Title: this.title
      }
      this.$document.apiStream(payload).then(r => {
         if (this.$document.errors && this.$document.errors.length > 0) {
            this.loadingerror = true
            this.loading = false
            this.$swal(
               "Document Unavailable",
               "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
               "error"
            );
         } else {
            this.pdfsrc = pdf.createLoadingTask(r);
            this.pdfsrc.promise.then(pdf => {
               this.numPages = pdf.numPages;
               setTimeout(() => {
                  URL.revokeObjectURL(r)
                  this.loading = false
               }, this.waitTimeMS);
            })
            .catch(err => {
               this.loadingerror = true
               this.loading = false
            });
            
         }
      }, e => {
         this.loadingerror = true
         this.loading = false
         this.$swal(
            "Document Unavailable",
            "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
            "error"
         );
      })
   }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/colors.scss";
@import "../../assets/css/application.scss";
@import "../../assets/css/validation.scss";

.doc-view {
   min-height: 400px;
   height: 400px;
   border: 1px solid #ddd;
   overflow-x: hidden;
   overflow-y: scroll;
}
.inner-doc-view {
   padding: 0;
   width: 100%;
}
</style>